import {
  ArrowPathIcon,
  CheckCircleIcon,
  ExclamationCircleIcon
} from '@heroicons/react/20/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const I18N_PREFIX = 'create_career.adjustment.'

/**
 * Ersetzt die drei Erfolgs-Toasts der Tabs. Ein Toast verschwindet nach fuenf
 * Sekunden, der Chip bleibt stehen: ohne Speichern-Button ist er die einzige
 * dauerhafte Auskunft darueber, ob der Stand auf dem Server liegt.
 *
 * "Gespeichert" wird deshalb bewusst nicht automatisch ausgeblendet.
 */
const SaveStateIndicator = ({ saveState, onRetry, disabled }) => {
  const { t } = useTranslation()

  if (saveState === 'idle') {
    return <p className='text-sm text-gray-700'>{t(I18N_PREFIX + 'hint')}</p>
  }

  const isError = saveState === 'error'
  const isSaving = saveState === 'saving'

  const Icon = isError
    ? ExclamationCircleIcon
    : isSaving
      ? ArrowPathIcon
      : CheckCircleIcon

  return (
    <div className='flex items-center gap-x-2'>
      <span
        className={clsx(
          'flex items-center gap-x-1.5 text-sm',
          isError ? 'text-red-700' : 'text-gray-700'
        )}
      >
        <Icon
          aria-hidden='true'
          className={clsx(
            'h-5 w-5',
            isError && 'text-red-600',
            isSaving && 'animate-spin text-gray-400',
            saveState === 'saved' && 'text-green-600'
          )}
        />
        {t(I18N_PREFIX + `save_state_${saveState}`)}
      </span>
      {isError && (
        <button
          type='button'
          onClick={onRetry}
          // Waehrend der Abschluss laeuft, ist der Hook eingefroren und
          // retry() ein No-op. Der Button wird deshalb sichtbar inaktiv statt
          // still wirkungslos.
          disabled={disabled}
          className={clsx(
            'rounded text-sm font-semibold underline focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2',
            disabled
              ? 'cursor-default text-gray-400 no-underline'
              : 'text-blue-600 hover:text-blue-500'
          )}
        >
          {t(I18N_PREFIX + 'save_state_retry')}
        </button>
      )}
    </div>
  )
}

SaveStateIndicator.propTypes = {
  saveState: PropTypes.oneOf(['idle', 'saving', 'saved', 'error']).isRequired,
  onRetry: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

SaveStateIndicator.defaultProps = { disabled: false }

export default SaveStateIndicator
